import Div from '@/shared/Div';
import Paragraph from '@/shared/Paragraph';
import React from 'react';
import date from '@/utils/date';
import Calendar from '../../../public/images/calendar.png';
import ImageWithFallback from '@/globalComponents/image';

type ExtendedWarrantyProps = {
  endDate: string;
  planDuration: number;
  planTitle: string;
};
const ExtendedWarrantyCard = ({ endDate, planDuration, planTitle }: ExtendedWarrantyProps) => {
  return (
    <Div className="px-s6 py-s5 flex flex-col gap-s3 border bg-extended-warranty-gradient">
      <Paragraph className="text-h-4 md:text-hd-4 text-blue-400">{planTitle}</Paragraph>
      <Paragraph className="text-body-lg text-cti-secondary">
        {`Enjoy ${planDuration} years with no service fees`}
      </Paragraph>
      <Div className="flex gap-s3">
        <ImageWithFallback width={24} height={24} src={Calendar} alt="calendar icon" />
        <Paragraph className="text-body-lg">{`Valid till ${date.format(endDate, {
          month: 'long',
          day: 'numeric',
          year: 'numeric',
        })}`}</Paragraph>
      </Div>
    </Div>
  );
};

export default ExtendedWarrantyCard;
